import React from 'react'
import { Col, Row , Container } from 'react-bootstrap'
import Pricing from './style'
import PricingCard1 from "./Components1/Card"
import PricingCard2 from "./Components2/Card" 
import PricingCard3 from "./Components3/Card" 


const pricingValues ={
  cardOne : {
    monthly:{
      price: 495,
    },
    yearly:{
      price: "1,782",
    }
  },
  cardTwo : {
    monthly:{
      price: 495,
    },
    yearly:{
      price: "1,782",
    }
  },
  cardThree : {
    monthly:{
      price: 495,
    },
    yearly:{
      price: "4,248",
    }
  }
}

export default function PricingSection({...rest}){
  const [yearly,setYearly] = React.useState(false);
  const {cardOne,cardTwo,cardThree} =  pricingValues;
return(
<Pricing backgroundColor="#f3f4f6" {...rest}>
  <Container>
  <Pricing.Box pb="40px" pbXL="70px">
  <Row className="align-items-end justify-content-center">
        <Col xs="12" className="col-xl-7 col-lg-6">
          <Pricing.Box className="text-center text-lg-start">
            <Pricing.Subtitle>Ознакомтесь с нашими услугами</Pricing.Subtitle>
            <Pricing.Title>Прайс лист</Pricing.Title>
          </Pricing.Box>
        </Col>
        <Col xs="12" className="col-xl-5 col-lg-6">
          <Pricing.Button className="pricing-btn">
            <label className="mb-3 mb-lg-0">Ежемесячно</label>
            <div className="toggle-btn form-switch mb-3 mb-lg-0">
              <input className="form-check-input btn-toggle price-deck-trigger" type="checkbox" onChange={() => setYearly(!yearly)} checked={yearly}/>
            </div>
            <label className="mb-3 mb-lg-0">Полная стоимость</label>
            <h3 className="badge bg-yellow mb-3 mb-lg-0">SAVE 10%</h3>
          </Pricing.Button>
        </Col>
    </Row>
    </Pricing.Box>
    <Row className="justify-content-center">
      {/* Single Table */}
      <Col xs="12" className="col-lg-4 col-md-6 col-sm-9 col-xs-10">
          <PricingCard1 cardTitle={"Frontend"} backgroundColor={"#442cd6"} amount={yearly? cardOne.yearly.price : cardOne.monthly.price} yearlyPackage={yearly}/>
      </Col>
      {/* Single Table */}
      <Col xs="12" className="col-lg-4 col-md-6 col-sm-9 col-xs-10">
          <PricingCard2 cardTitle={"Backend"} backgroundColor={"#ff5722"} amount={yearly? cardTwo.yearly.price : cardTwo.monthly.price} yearlyPackage={yearly}/>
      </Col>
      {/* Single Table */}
      <Col xs="12" className="col-lg-4 col-md-6 col-sm-9 col-xs-10">
          <PricingCard3 cardTitle={"Python Foundations"} backgroundColor={"#442cd6"} amount={yearly? cardThree.yearly.price : cardThree.monthly.price} yearlyPackage={yearly}/>
      </Col>
    </Row>
  </Container>
</Pricing>

)
}